import React from 'react';
import { useAuth } from './auth_context';
import { useUserInfo } from './use_user_info';
import { Navigate } from 'react-router-dom';

const AdminProtectedRoute = ({ children }) => {
  const { isAuthReady, token } = useAuth();
  const { user, isLoading } = useUserInfo();

  if (!isAuthReady || isLoading) {
    return <div>Loading...</div>;
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  // Check if user has Admin role
  if (!user || user.role !== 'admin') {
    return <Navigate to="/" />;
  }

  return children;
};

export default AdminProtectedRoute; 